<template>
  <v-tooltip bottom>
    <div>{{ label }}</div>
    <template v-slot:activator="{ on }">
      <slot v-bind:on="on">
        <v-flex sm2 class="item">
          <v-btn
            :to="{ name: route }"
            class="navbar-button v-btn"
            v-on="on"
            text
          >
            <v-icon class="navbar-icon">{{ icon }}</v-icon>
          </v-btn>
          <span class="v-btn__content">{{ text }}</span>
        </v-flex>
      </slot>
    </template>
  </v-tooltip>
</template>

<script>
export default {
  name: "Item",
  props: {
    icon: { type: String },
    label: { type: String },
    route: { type: String },
    text: { type: String },
  },
};
</script>

<style scoped>
.v-btn {
  height: 55px !important;
}
.v-btn__content {
  font-size: small;
  display: flex;
  flex-direction:column;
  text-align: center;
  justify-content: center;
}
.item {
  padding-right: 4px;
  margin-left: auto;
  text-align: center;
}
</style>
